import { SymbolLayerSpecification } from 'mapbox-gl'

const withPriceLayout: SymbolLayerSpecification['layout'] = {
  'text-field': ['get', 'priceLabel'],
  'text-size': 12,
  'text-font': ['Open Sans Bold'],
  'text-anchor': 'center',
  'text-justify': 'center',
  'text-offset': [0.6, -0.35],
  'icon-allow-overlap': true,
  'text-ignore-placement': true,
  'text-allow-overlap': true,
  'icon-size': 0.25
}

const noPriceLayout: SymbolLayerSpecification['layout'] = {
  'text-field': '',
  'icon-allow-overlap': true,
  'icon-size': 0.25
}

const icaoLayout: SymbolLayerSpecification['layout'] = {
  'text-field': ['get', 'code'],
  'text-size': 12,
  'text-font': ['Open Sans Bold'],
  'text-offset': [0, 1.9],
  'text-ignore-placement': true,
  'text-allow-overlap': true,
  'text-anchor': 'center',
  'text-transform': 'uppercase',
  'text-justify': 'center',
  'text-optional': false,
  'icon-optional': false,
  'icon-allow-overlap': true,
  'icon-size': 0
}

const textPaint: SymbolLayerSpecification['paint'] = {
  'text-halo-color': '#000',
  'text-color': '#fff',
  'text-halo-width': 1
}

const priceTextPaint: SymbolLayerSpecification['paint'] = {
  'text-color': '#fff'
}

export { icaoLayout, noPriceLayout, priceTextPaint, textPaint, withPriceLayout }
